import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../../../../context/AppContext';

const formatPKR = (value) => {
  if (typeof value !== 'number') return value;
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR',
    maximumFractionDigits: 0,
  }).format(value);
};

const StatsCards = ({ dateRange }) => {
  const [statsData, setStatsData] = useState([]);
  const { baseUrl } = useContext(AppContext);

// NEW
  useEffect(() => {
    fetch(`${baseUrl}/admin/stats-overview?range=${encodeURIComponent(dateRange)}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        Accept: 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setStatsData(Array.isArray(data) ? data : []))
      .catch(() => setStatsData([]));
  }, [dateRange]);

  return (
    <div className="AdminSideDashboard__statsGrid">
      {statsData.map((stat, index) => (
        <div 
          key={index} 
          className="AdminSideDashboard__statCard AdminSideDashboard--slideUp"
          style={{ animationDelay: `${0.1 * (index + 1)}s` }}
        >
          <div className={`AdminSideDashboard__statIcon AdminSideDashboard__statIcon--${stat.color}`}>
            {stat.icon}
          </div>
          <div className="AdminSideDashboard__statContent">
            <div className="AdminSideDashboard__statLabel">{stat.label}</div>
            <div className="AdminSideDashboard__statValue">
              {stat.isCurrency ? formatPKR(stat.value) : stat.value}
            </div>
            {stat.change && (
              <div className={`AdminSideDashboard__statChange ${stat.positive ? 'AdminSideDashboard__statChange--positive' : 'AdminSideDashboard__statChange--negative'}`}>
                {stat.change} {stat.positive ? '↗' : '↘'}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;